import { AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  BulkRecipientRequest,
  CreateCampaignCommandRequest,
  CreateScheduledMessageCommand,
  CustomResultOfInteger,
  PhoneBookRecipientRequest,
  RegionalRecipient,
  SendSubTypes,
  SendTypes,
} from 'src/app/core/api/models';
import { CampaignsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
    selector: 'app-campaigns-form',
    templateUrl: './campaigns-form.component.html',
    standalone: false
})
export class CampaignsFormComponent
  extends BaseFormPageComponent
  implements OnInit, AfterViewChecked
{
  //#region Properties
  model: CreateCampaignCommandRequest = {};
  isSaveAfterSend: boolean = true;
  campaignId: number = null;
  //#endregion

  constructor(
    protected currentService: CampaignsService,

    private dialogRef: MatDialogRef<CampaignsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GetCampaignData
  ) {
    super();
    this.getCampaignData(data);
  }

  ngOnInit() {
    this.initForm();
  }

  getCampaignData(campaignData: GetCampaignData) {
    try {
      ConsoleService.info('campaignData', campaignData);

      const data = campaignData.model;

      this.model = {
        smsText: data?.smsBody,
        privateNumberId: data?.senderNumberId,
        sendType: campaignData?.sendType,
      };

      if (campaignData.sendType == SendTypes.Phonebook) {
        this.model.recipientsJson = JSON.stringify(
          campaignData.model.phonebookRecipients
        );
      }
      if (
        campaignData.sendType == SendTypes.Bulk ||
        campaignData.sendType == SendTypes.Bulk2
      ) {
        if (campaignData.model.bulkRecipients)
          this.model.recipientsJson = JSON.stringify(
            campaignData.model.bulkRecipients
          );
        else if (campaignData.model.regionalRecipients)
          this.model.recipientsJson = JSON.stringify(
            campaignData.model.regionalRecipients
          );
      }

      if (data.sendDateTimeChecked) {
        this.model.sendSubType = SendSubTypes.Direct;
        this.model.dateTimeNext = data.sendDateTime;
      } else if (data.sendPeriodChecked) {
        this.model.sendSubType = SendSubTypes.Periodic;
        this.model.periodType = data.periodTypeValue;
        this.model.period = data.periodText;
        this.model.dateTimeNext = data.periodStart;
        this.model.dateTimeEnd = data.periodEnd;
      } else if (data.gradualChecked) {
        this.model.sendSubType = SendSubTypes.Gradual;
        this.model.dateTimeNext = data.gradualStart;
        this.model.pageSize = data.gradualPageSize;
        this.model.period = data.periodText;
      }

      ConsoleService.info('model', this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateCampaignCommandRequest) {
    this.loading = true;

    this.currentService
      .campaignsCreateCampaignPost({
        body: {
          campaignCommandRequest: model,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe((result: CustomResultOfInteger) => {
        try {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.campaignId = +result.data;
            this.onSuccess();
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }

  //#endregion

  onClose() {
    this.dialogRef.close({
      isSaveAfterSend: false,
    });
  }

  onSuccess() {
    this.dialogRef.close({
      isSaveAfterSend: this.isSaveAfterSend,
      campaignId: this.campaignId,
      title: this.model.title,
    });
    this.unSubs();
  }

  onSaveNow() {
    if (this.form.invalid) return;
    this.isSaveAfterSend = false;
    this.baseCreateApi(this.model);
  }

  onSaveAfterSend() {
    if (this.form.invalid) return;
    this.isSaveAfterSend = true;
    this.onSuccess();
  }
}

export interface GetCampaignData {
  model?: GetCampaignDataModel;
  sendType?: SendTypes;
}

export interface GetCampaignDataModel extends CreateScheduledMessageCommand {
  phonebookRecipients: PhoneBookRecipientRequest[];
  bulkRecipients: BulkRecipientRequest[];
  regionalRecipients: RegionalRecipient[];
}
